
import { createRouter, createWebHistory } from 'vue-router'
import keycloak from '@/keycloak.js'
import Login from '../views/Login.vue'
import Dashboard from '../views/Dashboard.vue'
import Layout from '../Layout.vue'
import DepartmentMembershipRequestsIndexView from '../views/departments/membership/requests/DepartmentMembershipRequestsIndexView.vue'
import AbsenceRequestsIndexView from '../views/absences/requests/AbsenceRequestsIndexView.vue'

const routes = [
  { path: '/', component: Login, name: 'Login' },

  {
    path: '/admin',
    component: Layout,
    children: [
        {
            path: "/departments/membership-requests/exports/:exportId?",
            component: () => import("../views/departments/membership/requests/DepartmentMembershipRequestsExportsView.vue"),
            name: "department-membership-request-exports",
        },
      { 
        path: '', 
        component: Dashboard,
        name: "dashboard",
      }, 
      {
        path: "/departments/membership-requests",
        component: DepartmentMembershipRequestsIndexView,
        name: "Mudança de base de trabalho",
        
      },
      {
        path: "/absences/requests",
        component: AbsenceRequestsIndexView,
        name: "Férias"
      },
      {
        path: "/exports",
        component: () => import("../views/exports/ExportsView.vue"),
        name: "exports",
      }
    ],
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior() {
    return { left: 0, top: 0 }
  },
})

// Guard de autenticação
router.beforeEach((to, from, next) => {
    if (to.path.startsWith("/img/") || to.path.match(/\.(png|jpg|jpeg|ico|svg)$/)) {
        return next();
    }

    if (!keycloak.authenticated) {
        sessionStorage.setItem("redirectTo", to.fullPath);

        keycloak.login({
            redirectUri: window.location.origin + to.fullPath,
        });

        return;
    }

    if (to.name === "Login") {
        return next({ path: "/admin" });
    }

    next();
});


export default router
